<template>
  <div class="fts-console-search-input">
    <input 
      type="text"
      class="console-search-input fts-form-control"
      v-model="model"
      :placeholder="placeholder"
      :disabled="disabled"
      @focus="onFocus"
      @blur="onBlur"
      @keydown.tab.prevent="onTab"
      @keydown.enter.prevent="onEnter"
      @keydown.esc.prevent="onEsc"
      ref="ftsConsoleSearchInput" />
    <div 
      class="console-search-input-action" 
      :class="value ? 'times-icon' : 'search-icon'">
      <template v-if="onSearchLoading || loading">
        <fts-spinner show :size="17" />
      </template>
      
      <font-awesome-icon 
        :icon="['fas', 'times']" 
        fixed-width 
        v-else-if="value"
        @click="clearFilter" />

      <font-awesome-icon :icon="['fas', 'search']" fixed-width v-else />
    </div>
  </div>
</template>

<script>
import FTSSpinner from "../../elements/FTSSpinner";

export default {
  components: {
    "fts-spinner": FTSSpinner,
  },
  props: {
    value: String,
    placeholder: {
      type: String,
      default: 'Type something to search'
    },
    loading: Boolean,
    disabled: Boolean,
    debounceTime: {
      type: Number,
      default: 800,
    },
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  data: () => ({
    onSearchLoading: false,
  }),
  methods: {
    onTab() {
      this.$emit('keydown:tab');
    },
    onEnter() {
      this.$emit('keydown:enter');
    },
    onEsc() {
      this.clearFilter();
      this.$emit('keydown:esc');
    },
    onFocus() {
      this.$emit('input:focus');
    },
    onBlur() {
      this.$emit('input:blur');
    },
    onSearch() {
      this.$emit('input:search');
      this.onSearchLoading = false
    },
    focus() {
      this.$refs.ftsConsoleSearchInput.focus();
    },
    clearFilter() {
      this.model = null;
      this.$emit('input:clear');
    },
  },
  computed: {
    debounceSearch() {
      return _.debounce(this.onSearch, this.debounceTime);
    },
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.onSearchLoading = true;
        this.$emit('input', val);
        this.$emit('updateValue', val);
        this.debounceSearch();
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-console-search-input {
  position: relative;
  .console-search-input {
    @include placeholder($fontSize: 1.25rem, $color: $grayLightColor);
    height: calc(1.5em + 1.25rem + 2px);
    padding: 0.575rem 2.5rem 0.575rem 1rem;
    border-radius: 2em;
    border-width: 2px;
    font-size: 1.25rem;
    &:focus + .search-icon {
      svg {
        color: $primaryColor;
      }
    }
  }
  .console-search-input-action {
    @include absolute-center-y;
    font-size: .875rem;
    right: 1rem;
    svg {
      color: $grayLightColor;
    }
    &.search-icon {
      @include pointer-events-none;
    }
    &.times-icon {
      cursor: pointer;
    }
  }
}
</style>